import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RelayTransactionDetailRoutingModule } from './relay-transaction-detail-routing.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { DataModule } from 'libs/portal/src/modules/keepalive/components/data/data.module';
import { CardTableModule } from 'libs/portal/src/modules/tools/card-table/card-table.module';
import { SearchableComboboxModule } from 'libs/portal/src/modules/tools/searchable-combobox/searchable-combobox.module';
import { ToolsModule } from 'libs/portal/src/modules/tools/tools.module';
import { RelayRoutingModule } from '../../relay-routing.module';
import { RelayTransactionDetailComponent } from './relay-transaction-detail/relay-transaction-detail.component';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [RelayTransactionDetailComponent],
  imports: [
    CommonModule,
    RelayTransactionDetailRoutingModule,
    CommonModule,
    RelayRoutingModule,
    MaterialModule,
    DataModule,
    ToolsModule,
    CardTableModule,
    SearchableComboboxModule,
    NgApexchartsModule,
    CardTableModule,
    MaterialModule,
    MatTabsModule,
  ],
})
export class RelayTransactionDetailModule {}
